import { TerminalIcon } from "@heroicons/react/solid";

import { BasicTooltip } from "@/components/ui/Tooltip";
import { WorkflowNodeStatus } from "@/components/Workflows/types";

interface OutputLabelProps {
  nodeStatus?: WorkflowNodeStatus;
}

const OutputLabel: React.FC<OutputLabelProps> = ({ nodeStatus }) => {
  const isCompleted = nodeStatus === WorkflowNodeStatus.COMPLETED;
  const isSkipped = nodeStatus === WorkflowNodeStatus.SKIPPED;

  const baseClasses =
    "mr-2 flex items-center rounded-full px-2 py-1 text-sm font-medium transition-all duration-200";

  let statusClasses;
  let tooltipContent;

  if (isCompleted) {
    statusClasses = "bg-green-50 text-green-800 ring-2 ring-green-400 shadow-lg";
    tooltipContent =
      "This node completed and ended the workflow here. Any nodes after this were skipped.";
  } else if (isSkipped) {
    statusClasses = "bg-gray-50 text-gray-500 border border-dashed border-red-300";
    tooltipContent =
      "This output node was skipped. It may have been unreachable or another output node ran first.";
  } else {
    statusClasses = "bg-blue-100 text-blue-500";
    tooltipContent =
      "When this node runs, it ends the workflow and returns its result. Any nodes after this will be skipped.";
  }

  return (
    <BasicTooltip content={tooltipContent}>
      <span className={`${baseClasses} ${statusClasses}`}>
        <TerminalIcon className="mr-1 h-4 w-auto" />
        Output
      </span>
    </BasicTooltip>
  );
};

export default OutputLabel;
